export enum NotificationActionType {
    REDIRECT_TO_ABSOLUTE_URL = "redirect_to_absolute_url",
    REDIRECT_TO_RELATIVE_URL = "redirect_to_relative_url",
    REDIRECT_TO_CHAT_CHANNEL = "redirect_to_chat_channel",
    SHOW_POPUP = "show_popup",
    NONE = "none"
}

export interface RelativeURLType {
    type: NotificationActionType.REDIRECT_TO_RELATIVE_URL;
    relativeUrl: string;
}

export interface AbsoluteURLType {
    type: NotificationActionType.REDIRECT_TO_ABSOLUTE_URL;
    absoluteUrl: string;
}

export interface ChatChannelType {
    type: NotificationActionType.REDIRECT_TO_CHAT_CHANNEL;
    chatChannelId: string;
}

export interface PopupType {
    type: NotificationActionType.SHOW_POPUP;
    title: string;
    message: string;
}

export interface None{
    type: NotificationActionType.NONE;
}

export type NotificationActionTypes =
    | RelativeURLType
    | AbsoluteURLType
    | ChatChannelType
    | PopupType
    | None;